export default __webpack_public_path__ + "static/zf-2442c5760b3f458d76ad28d8bb974994.png";